import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-input-label',
    templateUrl: './input-label.component.html',
    styleUrls: ['./input-label.component.scss'],
    standalone: false
})
export class InputLabelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
